export default function Loader({label}) {
    return (
        <div className={'flex gap-3 items-center w-full justify-center'}>
            {label}
            <i className='bx bx-loader-alt bx-spin text-xl'></i>
        </div>
    )
}